import { RESEARCH, CLINIC } from "@/data/clinic";
import SEOHead from "@/components/SEOHead";
import { Link } from "react-router-dom";
import { BookOpen, ExternalLink } from "lucide-react";

export default function Research() {
  return (
    <div data-testid="research-page">
      <SEOHead
        title="Research & Publications | Dr. Ashutosh Mishra"
        description="Research, conference presentations and academic contributions by Dr. Ashutosh Mishra — Senior Diabetologist & Endocrinologist, Varanasi."
        path="/research-publications"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Research & Publications", url: "/research-publications" },
        ]}
      />
      <section className="bg-gradient-to-br from-green-50/60 via-white to-green-50/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <nav className="text-xs text-slate-500 mb-3">
            <Link to="/" className="hover:text-green-700">Home</Link> <span className="mx-1.5">/</span> <span className="text-slate-700">Research & Publications</span>
          </nav>
          <div className="text-xs uppercase tracking-[0.22em] text-green-700 font-medium">Academic work</div>
          <h1 className="font-poppins font-semibold text-4xl sm:text-5xl text-slate-900 mt-3 leading-tight">Research & Publications</h1>
          <p className="text-slate-600 text-lg mt-4 max-w-3xl">
            {CLINIC.doctorName} has actively participated in research, academic presentations and medical conferences in endocrinology, diabetes, metabolism and internal medicine. A selection of his work is listed below.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="space-y-5">
          {RESEARCH.map((r, i) => (
            <article key={i} data-testid={`research-${i}`} className="bg-white border border-slate-100 rounded-2xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-2xl bg-green-50 text-green-700 grid place-items-center shrink-0"><BookOpen className="w-5 h-5" /></div>
                <div className="flex-1">
                  <h2 className="font-poppins font-semibold text-lg sm:text-xl text-slate-900 leading-snug">{r.title}</h2>
                  <div className="text-xs text-green-700 uppercase tracking-wider mt-2">{r.venue} • {r.year}</div>
                  <p className="text-sm text-slate-600 mt-3 leading-relaxed">{r.description}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
